import React, { useEffect, useState } from 'react'
import {
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'

import {
  TEMPORAL_SETTINGS_AVAILABLE,
  activateTemporarySetting,
} from '../../lib/utils.js'
import VppaModal from '../../components/VppaModal/VppaModalTS'
import Platform from '../../platforms/index.js'

import { useAppSelector } from '../../hooks/useStore'
import { useNavigate, useParams } from 'react-router'
import VideoPlayerContainer from './VideoPlayerContainer'
import { useVideoDetails } from '../../hooks/useVideoDetails'
import { VideoPlayerProvider } from '../../components/VideoPlayer/VideoPlayerContext'

function VideoPlaybackScreen() {
  const navigate = useNavigate()
  const routerParams = useParams()
  const vppa_accepted = useAppSelector((state) => state.user.vppa_accepted)
  const validPassport = useAppSelector((state) => state.user.validPassport)
  const callSign = useAppSelector((state) => state.station.call_sign)
  const { videoDetails, error: errorGettingVideoDetails } = useVideoDetails(
    routerParams.url || ''
  )

  //TODO: Remove this when whole app is migrated to spatial navigation
  useEffect(() => {
    window.focusedComponent = {}
    window.focusedComponent.handleBySpatialNavigation = true
    return () => {
      window.focusedComponent.handleBySpatialNavigation = false
    }
  }, [])

  const [showVppaModal, setShowVppaModal] = useState(
    !vppa_accepted && videoDetails?.is_mvod && validPassport
  )

  if (errorGettingVideoDetails) {
    navigate('/error', { replace: true })
  }
  if (videoDetails?.url && !validPassport && !videoDetails?.isPlayable) {
    const windowUrl = window.location.href.split('/')[4]
    navigate(`/passport-upsell/${callSign}?video=${routerParams.url}`, {
      state: { goBackParameterUrl: windowUrl },
    })
  }

  useEffect(() => {
    Platform.reportAppReady()
  }, [])

  const { focusKey, ref } = useFocusable({
    isFocusBoundary: true,
    forceFocus: true,
  })

  const handleCloseVppaModal = ({ accepted }) => {
    if (accepted) {
      activateTemporarySetting(TEMPORAL_SETTINGS_AVAILABLE.VPPA)
      setShowVppaModal(false)
    } else {
      setShowVppaModal(false)
      navigate(`/video-details/${routerParams.url}`)
    }
  }

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref}>
        {showVppaModal ? (
          <VppaModal onCloseModal={handleCloseVppaModal} />
        ) : (
          videoDetails?.url && (
            <VideoPlayerProvider>
              <VideoPlayerContainer />
            </VideoPlayerProvider>
          )
        )}
      </div>
    </FocusContext.Provider>
  )
}

export default VideoPlaybackScreen
